import moment from "moment";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";

import { Button } from "@/components/ui/button";
import { InputGroup } from "@/components/ui/input";
import { fetchApi, getAuthCustomer, optionRole } from "@/helpers/h";
import { exportUptimeReport } from "@/helpers/h";
import { useData } from "@/stores/data";
import { useModal } from "@/stores/modal";
import { useState } from "react";
import { SelectGroup } from "@/components/ui/select";
import { useCustomerOptions } from "@/queries";

export default function ExportUptime() {
  const { close } = useModal();
  const { loading, setLoading } = useData();
  const { options: customerOptions, isLoading: isCustomersLoading } = useCustomerOptions();

  const [filter, setFilter] = useState({
    month_year: moment().format("YYYY-MM"),
    role: [],
    customer_id: null,
  });

  const handleExport = async () => {
    if (!filter.month_year) return toast.error("Month/Year is required");
    setLoading(true);

    const authCustomers = getAuthCustomer();
    let queryCustomerIds = authCustomers.length > 0
        ? authCustomers.map((obj) => obj.id).join(",")
        : "";

    if (filter.customer_id) {
      // If a specific customer is selected, pass only that one
      queryCustomerIds = filter.customer_id;
    }

    const res = await fetchApi({
      url:
        "/machine?" +
        new URLSearchParams({
          withSot: 1,
          withCustomer: 1,
          withServiceEngineer: 1,
          month_year: filter?.month_year,
          role: filter?.role,
          customer_ids: queryCustomerIds,
        }),
      method: "GET",
    });

    const excelData = exportUptimeReport(res?.data?.data || [], filter);

    // Convert to Excel
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Uptime Report");

    // Generate filename
    const filename = `${
      filter.role?.length > 0
        ? filter.role?.length == 1
          ? filter.role.includes("flm")
            ? "flm"
            : filter.role.includes("cit")
              ? "cit"
              : filter.role.includes("cv")
                ? "cv"
                : "se"
          : filter.role.join("_")
        : ""
    }uptime_report_${moment().format("hhmm_DDMMYYYY")}.xlsx`;

    // Download Excel file
    XLSX.writeFile(wb, filename);
    setLoading(false);
  };

  return (
    <div className="flex flex-col gap-[20px] bg-white rounded-[8px] md:rounded-[12px] lg:rounded-[16px] p-[24px] max-h-[90dvh] overflow-y-auto overflow-x-hidden">
      <h2 className="font-bold md:w-[500px] text-[24px]">Export Uptime Report</h2>
      
      <InputGroup
        label="Month/Year"
        type="month"
        value={filter?.month_year || ""}
        disabled={loading}
        onChange={(e) => {
          setFilter({
            ...filter,
            month_year: e.target.value,
          });
        }}
      />
      
      <SelectGroup
        label="Customer"
        menuPosition="fixed"
        isClearable
        isDisabled={isCustomersLoading || loading}
        placeholder="Select Customer"
        className="w-full"
        options={customerOptions}
        value={
          customerOptions && customerOptions.find((obj) => obj.value === filter.customer_id)
        }
        onChange={(e) => {
          setFilter({
            ...filter,
            customer_id: e ? e.value : null,
          });
        }}
      />

      <SelectGroup
        label="Engineer Type"
        menuPosition="fixed"
        isClearable
        isMulti
        isDisabled={!optionRole || loading}
        placeholder="Select Engineer Type"
        className="w-full"
        options={optionRole}
        value={optionRole.filter((obj) => {
          return filter.role?.includes(obj.value);
        })}
        onChange={(e) => {
          setFilter({
            ...filter,
            role: e?.map((obj) => obj.value) || [],
          });
        }}
      />

      <div className="flex gap-2 flex-col md:flex-row gap-3 justify-end">
        <Button variant="gray" onClick={close} isLoading={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleExport} isLoading={loading}>
          Export to Excel
        </Button>
      </div>
    </div>
  );
}
